import Cliente from "../Cliente";

export const getCountries = () => {
  return Cliente.setBearerToken()
    .getCliente()
    .get(`${process.env.REACT_APP_API_URL}country/`);
};
